import { Skeleton } from '@mui/material';

const GenericSkeleton = (): JSX.Element => (
    <>
        <Skeleton animation="pulse" variant="rectangular" width="100%" sx={{ marginY: '20px' }} />
        <Skeleton animation="pulse" variant="rectangular" width="100%" sx={{ marginY: '20px' }} />
        <Skeleton animation="pulse" variant="rectangular" width="100%" sx={{ marginY: '20px' }} />
        <Skeleton animation="pulse" variant="rectangular" width="100%" sx={{ marginY: '20px' }} />
        <Skeleton animation="pulse" variant="rectangular" width="100%" sx={{ marginY: '20px' }} />
        <Skeleton animation="pulse" variant="rectangular" width="100%" sx={{ marginY: '20px' }} />
        <Skeleton animation="pulse" variant="rectangular" width="100%" sx={{ marginY: '20px' }} />
        <Skeleton animation="pulse" variant="rectangular" width="100%" sx={{ marginY: '20px' }} />
    </>
);

export default GenericSkeleton;
